"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgWrapper = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const rotate = (0, theme_1.keyframes) `
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const animation = () => (0, theme_1.css) `
    ${rotate} 2s linear infinite;
  `;
exports.SvgWrapper = theme_1.styled.div `
  animation: ${animation};
  width: ${({ size }) => size !== null && size !== void 0 ? size : 19}px;
  height: ${({ size }) => size !== null && size !== void 0 ? size : 19}px;
  display: inline-block;
`;
